export const INIT_CONFIG = "INIT_CONFIG";

export function initConfig(data) {
    return { type: INIT_CONFIG, data }
};



// WEBPACK FOOTER //
// ./src/services/store/reducers/config/actions.js